import { render, staticRenderFns } from "./PageInventaire.vue?vue&type=template&id=00be8e2c&"
import script from "./PageInventaire.vue?vue&type=script&lang=js&"
export * from "./PageInventaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00be8e2c')) {
      api.createRecord('00be8e2c', component.options)
    } else {
      api.reload('00be8e2c', component.options)
    }
    module.hot.accept("./PageInventaire.vue?vue&type=template&id=00be8e2c&", function () {
      api.rerender('00be8e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Stocks/PageInventaire.vue"
export default component.exports